import React, { useEffect } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import WhatsAppFloat from '../components/WhatsAppFloat';

const About = () => {
    useEffect(() => {
        // Force hide spinner immediately
        const spinner = document.getElementById('spinner');
        if (spinner) {
            spinner.classList.remove('show');
            spinner.style.display = 'none';
            spinner.style.opacity = '0';
            spinner.style.visibility = 'hidden';
        }
        if (window.WOW) {
            new window.WOW().init();
        }
    }, []);

    return (
        <>
            <WhatsAppFloat />
            <Navbar />

            {/* Page Header Start */}
            <div className="container-fluid page-header mb-5 wow fadeIn" data-wow-delay="0.1s">
                <div className="container">
                    <h1 className="display-3 mb-4 animated slideInDown">About</h1>
                    <nav aria-label="breadcrumb animated slideInDown">
                        <ol className="breadcrumb mb-0">
                            <li className="breadcrumb-item"><a href="/">Home</a></li>
                            <li className="breadcrumb-item"><a href="/about">Pages</a></li>
                            <li className="breadcrumb-item active" aria-current="page">About</li>
                        </ol>
                    </nav>
                </div>
            </div>
            {/* Page Header End */}

            {/* About Start */}
            <div className="container-xxl py-5">
                <div className="container">
                    <div className="row g-4 align-items-end mb-4">
                        <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.1s">
                            <img className="img-fluid rounded" src="img/images/fulllogowebbears.png" alt="About WebBears" />
                        </div>
                        <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.3s">
                            <p className="d-inline-block border rounded text-primary fw-semi-bold py-1 px-3">About Us</p>
                            <h1 className="display-5 mb-4">At WebBears</h1>
                            <p className="mb-4">We are more than just a web development company, we are a team of eight passionate individuals who have come together to form a creative force to be reckoned with.
                                We're not just a team; we're a pride of WebBears, and we're here to help you "Unleash Your Brand & Roar With WebBears."
                            </p>
                            <div className="border rounded p-4">
                                <nav>
                                    <div className="nav nav-tabs mb-3" id="nav-tab" role="tablist">
                                        <button className="nav-link fw-semi-bold active" id="nav-story-tab" data-bs-toggle="tab"
                                            data-bs-target="#nav-story" type="button" role="tab" aria-controls="nav-story"
                                            aria-selected="true">Story</button>
                                        <button className="nav-link fw-semi-bold" id="nav-mission-tab" data-bs-toggle="tab"
                                            data-bs-target="#nav-mission" type="button" role="tab" aria-controls="nav-mission"
                                            aria-selected="false">Mission</button>
                                        <button className="nav-link fw-semi-bold" id="nav-vision-tab" data-bs-toggle="tab"
                                            data-bs-target="#nav-vision" type="button" role="tab" aria-controls="nav-vision"
                                            aria-selected="false">Vision</button>
                                    </div>
                                </nav>
                                <div className="tab-content" id="nav-tabContent">
                                    <div className="tab-pane fade show active" id="nav-story" role="tabpanel"
                                        aria-labelledby="nav-story-tab">
                                        <p>The story of WebBears begins with a shared passion for web development and a desire to make a lasting impact in the digital world.
                                            we came together with the vision of creating a web development company that stood out from the rest.
                                            We wanted to build more than websites, we wanted to build online experiences that left a mark..</p>
                                        <p className="mb-0">As a team, we decided to call ourselves WebBears, inspired by the powerful and creative characteristics of bears in the wild.
                                            Just like these magnificent creatures, we knew that our team could roar with creativity and expertise,
                                            ensuring that the success of our clients echoed far and wide.</p>
                                    </div>
                                    <div className="tab-pane fade" id="nav-mission" role="tabpanel"
                                        aria-labelledby="nav-mission-tab">
                                        <p>At WebBears, our mission is simple yet powerful: we aim to empower businesses and individuals to thrive in the digital age. </p>
                                        <p className="mb-0">We believe that every brand, no matter how big or small, deserves a strong online presence that captivates and engages its audience.
                                            We're here to turn your digital dreams into reality.</p>
                                    </div>
                                    <div className="tab-pane fade" id="nav-vision" role="tabpanel" aria-labelledby="nav-vision-tab">
                                        <p>Our vision at WebBears is to be at the forefront of innovation in web development.
                                            We envision a world where businesses can harness the full potential of the internet to grow and prosper. </p>
                                        <p className="mb-0">We strive to be the creative force behind this transformation, providing cutting-edge web solutions that set new industry standards.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            {/* About End */}

            <Footer />
        </>
    );
};

export default About;
